import ApiService from "./ApiService";

const AIModelService = {
    getAllModels(page) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/list?page=' + page).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getAIModelWithId(id) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/' + id).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getKintoneFields(data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/kintone/get_fields', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getInputsAndOutputWithAiModelId(id) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/' + id + '/list-inputs-outputs').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getLayersWithAiModelId(id) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/' + id + '/layers').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    createAIModel(data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/model/create', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    updateAIModel(aiModelId, data) {
        return new Promise((resolve, reject) => {
            ApiService.put('/model/' + aiModelId, data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    updateKintoneFields(id, data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/model/' + id + '/save-inputs-outputs', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    deleteAIModel(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete('/model/' + id).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getAIModelLayerWithAiModelIdAndLayerNo(aiModelLayer) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/' + aiModelLayer.model_id + '/layers/' + aiModelLayer.layer_no).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    createAIModelLayer(aiModelLayer) {
        return new Promise((resolve, reject) => {
            ApiService.post('/model/' + aiModelLayer.model_id + '/save-layers', aiModelLayer).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    updateAIModelLayer(aiModelLayer) {
        return new Promise((resolve, reject) => {
            ApiService.put('/model/' + aiModelLayer.model_id + '/layers/' + aiModelLayer.layer_no, aiModelLayer).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    deleteAIModelLayer(aiModelId, layerNo) {
        return new Promise((resolve, reject) => {
            ApiService.delete('/model/' + aiModelId + '/layers/' + layerNo).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    inference(aiModelId, record_query, training_id, pred_field_prefix, option_thresh) {
        return new Promise((resolve, reject) => {
            ApiService.post('/model/inference/' + aiModelId,
            {
                record_query,
                training_id,
                pred_field_prefix,
                option_thresh
            }).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getAllInferences(aiModelId, page) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/inferences/' + aiModelId + '?page=' + page).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    train(aiModelId, record_query, epochs, batch_size) {
        return new Promise((resolve, reject) => {
            ApiService.post('/model/train/' + aiModelId, {record_query, epochs, batch_size}).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    deleteTrainHistory(aiModelId, trainIndex) {
        return new Promise((resolve, reject) => {
            ApiService.delete('/model/trains/' + aiModelId + '/' + trainIndex).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getAllTrains(aiModelId, page) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/trains/' + aiModelId + '?page=' + page).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getAllFinishTrains(aiModelId,) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/trains/' + aiModelId + '/finish').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getTrainsLosses(aiModelId,trainIndex) {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/model/train-history/losses/' + aiModelId + '/' + trainIndex).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },

};

export default AIModelService